import './Button.style.css';

interface ButtonProps {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  title: string;
  disabled?: boolean;
}

export default function Button({ onClick, title, disabled }: ButtonProps) {
  return (
    <button className="tgc-button" onClick={onClick} disabled={disabled}>
      {title}
    </button>
  );
}
